export const counties = ['Oakland', 'Livingston', 'Genesee', 'Washtenaw']

export const featuredCities = [
  'Howell',
  'Hartland',
  'Fowlerville',
  'Brighton',
  'New Hudson',
  'Novi',
  'Wixom',
  'Walled Lake',
  'Farmington',
  'Farmington Hills',
  'West Bloomfield',
  'Commerce Township',
  'South Lyon',
  'Milford',
  'Ann Arbor',
]

export type CountyArea = {
  county: string
  cities: string[]
}

export const countyCities: CountyArea[] = [
  {
    county: 'Oakland County',
    cities: [
      'Auburn Hills',
      'Farmington',
      'Lakeville',
      'Oxford',
      'Walled Lake',
      'Berkley',
      'Ferndale',
      'Leonard',
      'Pleasant Ridge',
      'Waterford',
      'Birmingham',
      'Franklin',
      'Madison Heights',
      'Pontiac',
      'West Bloomfield',
      'Bloomfield Hills',
      'Hazel Park',
      'Milford',
      'Rochester',
      'White Lake',
      'Clarkston',
      'Highland',
      'New Hudson',
      'Royal Oak',
      'Wixom',
      'Clawson',
      'Holly',
      'Novi',
      'South Lyon',
      'Commerce Township',
      'Huntington Woods',
      'Oak Park',
      'Southfield',
      'Davisburg',
      'Keego Harbor',
      'Oakland',
      'Troy',
      'Drayton Plains',
      'Lake Orion',
      'Ortonville',
      'Union Lake',
    ],
  },
  {
    county: 'Livingston County',
    cities: [
      'Brighton',
      'Fowlerville',
      'Hamburg',
      'Howell',
      'Pinckney',
      'Cohoctah',
      'Gregory',
      'Hartland',
      'Lakeland',
    ],
  },
  {
    county: 'Genesee County',
    cities: [
      'Atlas',
      'Fenton',
      'Genesee',
      'Linden',
      'Swartz Creek',
      'Burton',
      'Flint',
      'Goodrich',
      'Montrose',
      'Clio',
      'Flushing',
      'Grand Blanc',
      'Mount Morris',
      'Davison',
      'Gaines',
      'Lennon',
      'Otisville',
    ],
  },
  {
    county: 'Washtenaw County',
    cities: [
      'Ann Arbor',
      'Dexter',
      'Saline',
      'Willis',
      'Bridgewater',
      'Manchester',
      'Whitmore Lake',
      'Ypsilanti',
      'Chelsea',
      'Salem',
      'Whittaker',
    ],
  },
]
